function rotateArray<T>(array: T[], numberOfRotates: number): T[] {
	numberOfRotates = numberOfRotates % array.length;

	if (!numberOfRotates) {
		return array;
	}

	return array.concat(array.splice(0, numberOfRotates));
}

export const arrayService = { rotateArray };
